import React from "react";

// REDUX
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { StyledModalRoot } from "../../styled/modal";
import { ButtonWarningNoShadow } from "../../styled/button";
// ICONS
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// COLORS
import { grey, orange } from "@mui/material/colors";

export default function AlertModal({
  show,
  label = "Atenção",
  message,
  btnLabel = "Ok",
  handleAction,
}) {
  return (
    <Modal
      aria-labelledby="alert-modal"
      aria-describedby="shows-alert-message"
      open={show}
      onClose={() => {}}
      closeAfterTransition
      sx={{
        zIndex: 9999,
        border: "none",
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show} unmountOnExit>
        <StyledModalRoot width="30%" height="40%" overflow={"auto"}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            height="100%"
            p={2}
          >
            <Box>
              <Typography
                id="alert-modal-title"
                variant="h6"
                align="center"
                gutterBottom
                sx={{
                  color: orange["900"],
                  fontWeight: 700,
                }}
              >
                {label}
              </Typography>
              <Divider />
              <Typography
                id="alert-modal-message"
                variant="h6"
                align="center"
                sx={{
                  mt: 2,
                  color: grey["700"],
                }}
              >
                {message}
              </Typography>
            </Box>
            <Box
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ButtonWarningNoShadow
                variant="contained"
                startIcon={<CheckCircleIcon />}
                fullWidth
                onClick={handleAction}
              >
                {btnLabel}
              </ButtonWarningNoShadow>
            </Box>
          </Box>
        </StyledModalRoot>
      </Fade>
    </Modal>
  );
}
